
export const clientVersion = "0.0.9";

export const clientInfoVersion = "0.0.9+Branch.master.Sha.7324ee05fd9479874a74c62f081e9e8dca20963b";

